import { render, staticRenderFns } from "./RegoCart.vue?vue&type=template&id=047b79bc&scoped=true&"
import script from "./RegoCart.vue?vue&type=script&lang=js&"
export * from "./RegoCart.vue?vue&type=script&lang=js&"
import style0 from "./RegoCart.vue?vue&type=style&index=0&id=047b79bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b79bc",
  null
  
)

export default component.exports